/**
 * Cart Discount Badge Click Handler
 *
 * Lightweight event delegation handler for cart discount badge clicks.
 * This file loads early (non-module) to ensure the handler is ready before the badge appears.
 *
 * Handles clicks on discount badges that encourage users to add more items for bundle discounts.
 */

(function() {
  'use strict';

  /**
   * Event delegation for cart discount badge clicks
   * Listens on document level to catch clicks on badges added via AJAX or initial render
   */
  document.addEventListener('click', function(e) {
    // Check if the clicked element is or is inside a cart discount badge
    const badge = e.target.closest('.cart-discount-badge');
    if (!badge) return;

    e.preventDefault();
    console.log('Cart discount badge clicked');

    // Find the first active (non-additional) cart item's quantity selector
    const allQuantitySelectors = document.querySelectorAll('quantity-selector-component');
    let firstActiveSelector = null;

    for (let i = 0; i < allQuantitySelectors.length; i++) {
      const selector = allQuantitySelectors[i];

      // Skip additional product items (add-ons like "Tekst onder borduring")
      if (selector.hasAttribute('data-is-additional')) continue;

      firstActiveSelector = selector;
      break;
    }

    if (!firstActiveSelector) {
      console.error('Could not find any active quantity selector');
      return;
    }

    console.log('Found first active quantity selector');

    // Find and click the plus button to increase quantity
    const plusButton = firstActiveSelector.querySelector('button[name="plus"]');
    if (plusButton) {
      console.log('Clicking plus button to add discount item');
      plusButton.click();
    } else {
      console.error('Could not find plus button in quantity selector');
    }
  });

  console.log('Cart discount badge handler initialized');
})();
